<template>
  <div class="staff-profile-quality-addon">
    <div class="addon-head">
      <div>
        <span>HRM_STAFF_PROFILE_QUALITY</span>
        <h2>员工档案完整度治理</h2>
        <p>聚合员工主数据、角色、部门、资料文件和参保配置，识别关键字段缺失、资料断点和重复身份风险。</p>
      </div>
      <el-button type="primary" icon="el-icon-refresh" :loading="loading" @click="loadData">刷新</el-button>
    </div>

    <el-row :gutter="16" class="metric-row">
      <el-col v-for="item in metrics" :key="item.label" :xs="24" :sm="12" :lg="6">
        <div class="metric-card" :class="item.tone">
          <span>{{ item.label }}</span>
          <strong>{{ item.value }}</strong>
          <em>{{ item.meta }}</em>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :lg="14">
        <el-card shadow="never">
          <div slot="header">部门档案质量排行</div>
          <el-table :data="overview.deptQualityRanking" size="small" v-loading="loading">
            <el-table-column prop="dept_name" label="部门" min-width="130" />
            <el-table-column prop="active_staff_count" label="在职" width="80" />
            <el-table-column prop="missing_phone_count" label="电话缺失" width="90" />
            <el-table-column prop="missing_birthday_count" label="生日缺失" width="90" />
            <el-table-column prop="no_role_count" label="角色缺口" width="90" />
            <el-table-column prop="no_docs_count" label="资料缺口" width="90" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="10">
        <el-card shadow="never">
          <div slot="header">字段缺口分布</div>
          <div class="status-list">
            <div v-for="item in overview.fieldGapDistribution" :key="item.gap_name" class="status-item">
              <span>{{ item.gap_name }}</span>
              <strong>{{ item.gap_count }}</strong>
              <em>人</em>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16" class="lower-row">
      <el-col :xs="24" :lg="15">
        <el-card shadow="never">
          <div slot="header">高风险档案清单</div>
          <el-table :data="overview.highRiskStaffList" size="small" v-loading="loading">
            <el-table-column prop="code" label="工号" width="100" />
            <el-table-column prop="staff_name" label="姓名" width="110" />
            <el-table-column prop="dept_name" label="部门" min-width="120" />
            <el-table-column prop="phone" label="电话" width="130" />
            <el-table-column prop="birthday" label="生日" width="110" />
            <el-table-column prop="gap_score" label="缺口分" width="90" />
          </el-table>
        </el-card>
      </el-col>
      <el-col :xs="24" :lg="9">
        <el-card shadow="never">
          <div slot="header">重复工号</div>
          <el-table :data="overview.duplicateIdentityList" size="small" v-loading="loading" empty-text="暂无重复">
            <el-table-column prop="code" label="工号" width="110" />
            <el-table-column prop="duplicate_count" label="数量" width="70" />
            <el-table-column prop="staff_names" label="员工" min-width="130" />
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-card class="lower-row" shadow="never">
      <div slot="header">档案更新时间趋势</div>
      <div class="trend-list">
        <div v-for="item in overview.monthlyUpdateTrend" :key="item.month_label" class="trend-item">
          <span>{{ item.month_label }}</span>
          <strong>{{ item.update_count }}</strong>
          <em>次更新</em>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getStaffProfileQualityOverview } from '../api/staffProfileQuality'

export default {
  name: 'StaffProfileQualityOverview',
  data () {
    return {
      loading: false,
      overview: {
        staffCount: 0,
        activeStaffCount: 0,
        criticalGapStaffCount: 0,
        noRoleStaffCount: 0,
        noDocsStaffCount: 0,
        noInsuranceStaffCount: 0,
        fieldGapDistribution: [],
        deptQualityRanking: [],
        highRiskStaffList: [],
        duplicateIdentityList: [],
        monthlyUpdateTrend: []
      }
    }
  },
  computed: {
    metrics () {
      return [
        { label: '员工档案', value: this.overview.staffCount, meta: `${this.overview.activeStaffCount || 0} 人在职` },
        { label: '关键缺口', value: this.overview.criticalGapStaffCount, meta: '工号/姓名/电话/部门', tone: 'red' },
        { label: '角色缺口', value: this.overview.noRoleStaffCount, meta: `${this.overview.noDocsStaffCount || 0} 人无资料`, tone: 'orange' },
        { label: '参保缺口', value: this.overview.noInsuranceStaffCount, meta: '在职人员未配置', tone: 'blue' }
      ]
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      getStaffProfileQualityOverview().then(response => {
        if (response.code === 200) {
          this.overview = Object.assign({}, this.overview, response.data || {})
        } else {
          this.$message.warning(response.message || '员工档案完整度治理加载失败')
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.staff-profile-quality-addon {
  padding: 20px;
  background: #f5f7fb;
  min-height: 100%;
}

.addon-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 22px 24px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.addon-head span {
  display: block;
  margin-bottom: 8px;
  color: #7c2d12;
  font-size: 12px;
  font-weight: 700;
}

.addon-head h2 {
  margin: 0 0 8px;
  color: #17233d;
  font-size: 24px;
}

.addon-head p {
  margin: 0;
  color: #5f6f89;
}

.metric-row {
  margin-bottom: 16px;
}

.metric-card {
  min-height: 118px;
  padding: 18px;
  margin-bottom: 16px;
  background: #ffffff;
  border: 1px solid #e6ebf2;
  border-radius: 6px;
}

.metric-card span,
.metric-card em {
  display: block;
  color: #6b7a90;
  font-style: normal;
}

.metric-card strong {
  display: block;
  margin: 10px 0 8px;
  color: #17233d;
  font-size: 30px;
  line-height: 1;
}

.metric-card.red strong {
  color: #d93026;
}

.metric-card.orange strong {
  color: #d9822b;
}

.metric-card.blue strong {
  color: #2f6fec;
}

.lower-row {
  margin-top: 16px;
}

.status-list,
.trend-list {
  display: grid;
  gap: 10px;
}

.status-item,
.trend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f7;
  border-radius: 6px;
}

.status-item span,
.status-item em,
.trend-item span,
.trend-item em {
  color: #5f6f89;
  font-style: normal;
}

.status-item strong,
.trend-item strong {
  color: #17233d;
  font-size: 16px;
}
</style>
